import Store from '@/store';
import { endSession } from 'sociolla-analytics/actions/session';
const Config = require('~/config/default.env').default;
import Q from 'q';
import errorMessageSwitcher from '@/shared/mixins/ErrorMessageSwitcher';

let cancelCheck;
const centralLoginUrl = Config.CENTRAL_LOGIN_WEB_URL;

export default {
  async me(vm) {
    // const self = this;
    // await axios.get(Config.MS_SSO_BROKER_API_URL)
    return axios.get(Config.MS_ACCOUNTS_API_URL + '/user/me', { withCredentials: true }).then((response) => {
      Store.commit('meCalled', true, { module: 'auth' });
      if (response.status === 200 && response.data.success) {
        Store.commit('loggedIn', true, { module: 'auth' });
        if (
          'clients' in response.data.data &&
          'dashboard' in response.data.data.clients &&
          'token' in response.data.data.clients.dashboard
        ) {
          Store.commit('setToken', response.data.data.clients.dashboard.token);
        }
        Store.commit('profileState', response.data.data, { module: 'auth' });
        Store.commit('userProfile', response.data.data, { module: 'auth' });
        Store.commit('setUserPoints', response.data.data.points, {
          module: 'auth',
        });
        // Store.commit("modalAuth", 0, {module: 'auth'});
        // Store.dispatch('lockBg', false)

        // self.getUserPoints()

        // if(Store.state.nextURL) {
        //   window.location.replace(Store.state.nextURL);
        // } else if(Store.state.redirectUrl) {
        //   vm.$router.push(Store.state.redirectUrl)
        //   Store.commit('redirectUrl', '')
        // } else {
        //   vm.$router.push('/')
        // }
      } else {
        Store.commit('loggedIn', false, { module: 'auth' });
        Store.commit('profileState', null, { module: 'auth' });
        Store.commit('userProfile', null, { module: 'auth' });
        Store.commit('setMessageLimit', false, { module: 'auth' });
        Store.commit('setMessageLimitCount', '', { module: 'auth' });
        Store.commit('setMessageUserDeleted', false, { module: 'auth' });
        // Store.commit("modalAuth", 0, {module: 'auth'});
      }
      return response;
    });
  },

  login(data, otherSource) {
    if (!Store.state.redirectUrl) {
      Store.commit('setRedirectURL', data.$router.history.current.fullPath, {
        module: 'auth',
      });
    }

    if (typeof cancelCheck === 'object') {
      cancelCheck.cancel();
    }
    const payload = {};
    let endpoint = 'login';
    if (!otherSource) {
      (payload['email'] = data.loginData.username),
        (payload['password'] = data.loginData.password),
        (payload['source'] = window.innerWidth > 1100 ? 'review-web-desktop' : 'review-web-mobile');
    } else {
      // other source must have name and token
      (payload['acquisition_source'] = otherSource.name), (payload['access_token'] = otherSource.token);
      endpoint += `/${otherSource.name}`;
    }
    return axios
      .post(Config.MS_SOCO_PUBLIC_API_URL + `/auth/${endpoint}`, payload)
      .then(async (response) => {
        if (response.status == '200') {
          data.showLoader = false;
          if (typeof response.data.data !== 'undefined') {
            if (
              response.data.data.user.acquisition_source === 'facebook' ||
              response.data.data.user.is_fb ||
              response.data.data.user.is_google ||
              response.data.data.user.is_google_registered_pending
            ) {
              const isIncomplete = await Store.dispatch('incompleteUserInfo', response.data.data.user, {
                module: 'auth',
              });
              if (isIncomplete) {
                const nextURL = await Store.dispatch('completeProfileURL', response.data.data.user, { module: 'auth' });
                window.location.replace(nextURL);
                return response;
              }
            }
            Store.commit('loggedIn', true, { module: 'auth' });
            if (
              'user' in response.data.data &&
              'clients' in response.data.data.user &&
              'dashboard' in response.data.data.user.clients &&
              'token' in response.data.data.user.clients.dashboard
            ) {
              Store.commit('setToken', response.data.data.user.clients.dashboard.token);
            }
            Store.commit('profileState', response.data.data.user, {
              module: 'auth',
            });
            Store.commit('userProfile', response.data.data.user, {
              module: 'auth',
            });
            this.beautyProfile(response.data.data.user);
            this.me();
            data.$store.commit('setDataModal', {
              modalName: 'loginPage',
              value: 0,
            });
            if (Store.state.modalShareFromLogin) {
              Store.commit(
                'toggleModalGlobalState',
                { modalName: 'shareExperience' },
                {
                  module: 'modal',
                }
              );
              Store.commit('setModalShareFromLogin', false);
            }
            data.$toasted.global.show('Login Successful. Welcome!');
            if (Store.state.nextURL) {
              window.location.replace(Store.state.nextURL);
            } else if (Store.state.redirectUrl) {
              data.$router.push(Store.state.redirectUrl).catch(() => {});
              Store.commit('setRedirectURL', '', { module: 'auth' });
            } else {
              data.$router.push('/');
            }
          } else {
            // throw new TypeError("Silakan coba lagi dalam beberapa saat.")
            data.$toasted.global.error('Wrong Username / Email / Password.');
          }
          return true;
        }
        return response;
      })
      .catch((error) => {
        data.showLoader = false;
        // if(error.response && error.response.status === 401) {
        //   data.$toasted.global.error('Username / Email / Password  salah.')
        //   // Store.commit('setMessageLogin', 'Username / Email / Password  salah.')
        // } else {
        //     data.$toasted.global.error('Silakan coba lagi dalam beberapa saat.')
        // }
        if (error && error.response && error.response.status) {
          if (error.response.status === 401 && error.response.data.data.errorCode === 'INCORRECT_PASSWORD') {
            // INCORRECT_PASSWORD
            data.$toasted.global.error('Wrong Password Entered');
          } else if (
            error.response &&
            error.response.status === 401 &&
            error.response.data.data.errorCode === 'Third_failed_login_attempt'
          ) {
            data.$toasted.global.error(
              error.response.data.data.message
                ? error.response.data.data.message
                : 'Wrong Password Entered, Please click Forgot Password'
            );
          } else if (
            error.response &&
            error.response.status === 401 &&
            error.response.data.data.errorCode === 'Fourth_failed_login_attempt'
          ) {
            Store.commit('setMessageLimit', true, { module: 'auth' });
            Store.commit('setMessageLimitCount', 4, { module: 'auth' });
            data.$toasted.global.error(
              error.response.data.data.message
                ? error.response.data.data.message
                : 'Wrong Password Entered. Please Reset Your Password before the account is blocked'
            );
          } else if (
            error.response.status == 401 &&
            error.response.data.data.errorCode == 'ACCOUNT_LOCKED_FOR_TOO MANY_FAILED_ATTEMPTS!'
          ) {
            Store.commit('setMessageLimit', true, { module: 'auth' });
            Store.commit('setMessageLimitCount', 5, { module: 'auth' });
            data.$toasted.global.error(
              'Your account is blocked because 5 times you failed to login. Please Reset Your Password to access the account'
            );
          } else if (error.response.status === 404 && error.response.data.data.errorCode === 'USER_ALREADY_REMOVED') {
            // INCORRECT_PASSWORD
            Store.commit('setMessageLimit', true);
            Store.commit('setMessageUserDeleted', true);
            data.$toasted.global.error('Akun kamu tidak dapat diakses.');
          } else if (error.response.status == 404) {
            // USER_NOT_FOUND
            if (/^.+@.+\..+$/.test(data.loginData.username)) {
              data.$toasted.global.error('Email not registered.');
            } else {
              data.$toasted.global.error('Username not found.');
            }
          } else {
            const message =
              error.response &&
              (error.response.message ||
                (error.response.data && error.response.data.message) ||
                (error.response.data.data && error.response.data.data.message));
            data.$toasted.global.error(message);
          }
        }
        data.showLoader = false;
        if (error.response && (error.response.status == 307 || error.response.status == 405)) {
          window.location.reload(true);
        }
        return error;
      });
  },

  registerDetail(data) {
    const payload = {};
    const social_media = {};
    if (data.registerData.social_url) {
      for (const key in data.registerData.social_url) {
        social_media[key] = {};
        social_media[key]['url'] = data.registerData.social_url[key];
      }
    }
    let province = {};
    // let district = {};
    let city = {};

    data.registerData.province.map(function (row) {
      if (row._id == data.registerData.province_id) {
        province = {
          id: data.registerData.province_id,
          name: row.name,
        };
      }
    });
    data.registerData.district.map(function (row) {
      if (row._id == data.registerData.district_id) {
        district = {
          id: data.registerData.district_id,
          name: row.name,
        };
      }
    });
    data.registerData.city.map(function (row) {
      if (row._id == data.registerData.city_id) {
        city = {
          id: data.registerData.city_id,
          name: row.name,
        };
      }
    });
    data.registerData.username ? (payload.user_name = data.registerData.username) : '';
    data.registerData.email ? (payload.email = data.registerData.email) : '';
    data.registerData.phone ? (payload.phone_no = data.registerData.phone) : '';
    payload.is_reset_first_password = true;
    payload.is_reset_first_newsletter = false;
    payload.is_reset_first_password = false;
    payload.is_reset_first_interest = false;
    data.registerData.image ? (payload.image = data.registerData.image) : '';
    data.registerData.firstname ? (payload.first_name = data.registerData.firstname) : '';
    payload.name = data.registerData.firstname
      ? data.registerData.firstname + ' ' + data.registerData.lastname
      : data.registerData.lastname;
    data.registerData.lastname ? (payload.last_name = data.registerData.lastname) : '';
    data.registerData.nickname ? (payload.nick_name = data.registerData.nickname) : '';
    payload.city = city;
    payload.province = province;
    payload.country = { name: 'Indonesia' };
    data.registerData.password ? (payload.password = data.registerData.password) : '';
    payload.date_of_birth =
      data.registerData.birthday_year + '-' + data.registerData.birthday_month + '-' + data.registerData.birthday_date;
    data.registerData.gender_id ? (payload.gender = data.registerData.gender_id) : 'Female';
    data.registerData.salute_id ? (payload.salute = data.registerData.salute_id == 1 ? 'Ms' : 'Mr') : '';
    data.registerData.biodata ? (payload.bio = data.registerData.biodata) : '';
    payload.social = social_media;
    return axios
      .post(Config.MS_SOCO_PUBLIC_API_URL + '/auth/register/update', payload)
      .then((response) => {
        const user = response.data.data && response.data.data.user ? response.data.data.user : response.data.data;
        if (response.status == '200') {
          Store.commit('profileState', user, {
            module: 'auth',
          });
          Store.commit('userProfile', user, {
            module: 'auth',
          });
          Store.commit('loggedIn', true, { module: 'auth' });
          // Store.commit('newRegister', true, {module: 'auth'})
          data.$toasted.global.show('Register berhasil!');
          const isUserHasBeautyProfile = Boolean(
            user.beauty && user.beauty.length && user.beauty.find((beauty) => beauty.type === 'beauty-profile')
          );
          data.$router.push(isUserHasBeautyProfile ? '/' : '/beauty-profile');
        } else {
          data.showLoader = false;
          data.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
        }
      })
      .catch((error) => {
        data.showLoader = false;
        data.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
      });
  },

  skip() {
    this.me();
    Store.commit('modalAuth', 0, { module: 'auth' });
    Store.dispatch('lockBg', false);
  },

  logout(data) {
    if (typeof cancelCheck === 'object') {
      cancelCheck.cancel();
    }
    return axios
      .get(Config.MS_SOCO_PUBLIC_API_URL + '/auth/logout')
      .then((response) => {
        if (response.status == '200') {
          endSession();
          data.$toasted.global.show('Logout berhasil!');
          data.showLoader = false;
          Store.commit('loggedIn', false, { module: 'auth' });
          Store.commit('profileState', {}, { module: 'auth' });
          Store.commit('userProfile', {}, { module: 'auth' });
          Store.commit('closeOffCanvas');
          if (data.$route.name !== 'Dashboard') {
            data.$router.push('/');
          }
        } else {
          data.showLoader = false;
          data.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
        }
      })
      .catch((error) => {
        data.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
      });
  },

  forgot(data) {
    let payload = {};
    if (data.activetab === 'email') {
      payload = {
        email: data.forgot.email,
      };
    } else {
      payload = {
        phone_no: data.forgot.hp,
      };
    }

    return axios
      .post(Config.MS_SOCO_PUBLIC_API_URL + '/auth/forget-password', payload)
      .then((response) => {
        if (response.status == '200') {
          data.toggleModalAuth(0);
          // data.toggleModalAuth(4);
          // data.$toasted.global.show('Silakan cek email konfirmasi.')
          data.success = true;
          data.showLoader = false;
          data.showConfirmEmail = true;
          data.modalState = 0;
        } else {
          data.showLoader = false;
          data.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
        }
        return response;
      })
      .catch((error) => {
        data.showLoader = false;
        // let errorCode = error.response.data.errorCode;
        // if(errorCode === 'UNVERIFIED_PHONE'){
        //   data.$toasted.global.error('Nomor kamu belum terverifikasi, silakan reset password dengan email')
        // } else {
        //   data.$toasted.global.error(errorCode)
        // }
        // return error
        const errorCode = error.response.data.errorCode;
        const prefix = data.activetab === 'email' ? 'Email' : 'Nomor handphone';
        if (errorCode === 'UNVERIFIED_PHONE') {
          data.$toasted.global.error('Nomor kamu belum terverifikasi, silakan reset password dengan email');
        } else {
          data.$toasted.global.error(`${prefix} tidak terdaftar`);
        }
      });
  },

  reset(data) {
    return axios
      .post(Config.MS_SOCO_PUBLIC_API_URL + '/auth/reset-password', data.resetData)
      .then((response) => {
        if (response.status == '200') {
          data.$toasted.global.show('Password berhasil diubah.');
          data.success = true;
        } else {
          data.showLoader = false;
          data.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
        }
      })
      .catch((error) => {
        if (error.response.status === 402) {
          // if(error.response.data.data.new_password.length > 0) {
          // if (Store.state) {
          data.showLoader = false;
          data.$toasted.global.error('Password lama tidak boleh digunakan lagi.');
          // }
        } else {
          data.showLoader = false;
          data.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
        }
      });
  },

  register(data) {
    const self = this;

    // const datatosend = {
    //   email: data.registerData.email,
    //   user_name: data.registerData.username
    // };
    return Q.try(() => {
      if (!data.registerData.email || !data.registerData.username || !data.registerData.password) {
        data.showLoader = false;
        return null;
      }

      const payload = {
        acquisition_source: window.innerWidth > 1100 ? 'review-web-desktop' : 'review-web-mobile',
        email: data.registerData.email,
        user_name: data.registerData.username,
        password: data.registerData.password,
        first_name: data.registerData.firstname,
        last_name: data.registerData.lastname,
        phone_no: data.registerData.phone_no,
        phone_code: data.registerData.phone_code,
        gender: String(data.registerData.salute_id) === '1' ? 'Female' : 'Male',
        salute: String(data.registerData.salute_id) === '1' ? 'Ms' : 'Mr',
        recaptcha_token: data.recaptchaToken,
      };

      return axios
        .post(Config.MS_SOCO_PUBLIC_API_URL + '/auth/register', payload)
        .then((response) => {
          if (response.status == 200) {
            if (data.$SO.size(response.data.data) && response.data.data.user) {
              data.toggleModalAuth(4);
              Store.commit('loggedIn', true, { module: 'auth' });
              if (
                'user' in response.data.data &&
                'clients' in response.data.data.user &&
                'dashboard' in response.data.data.user.clients &&
                'token' in response.data.data.user.clients.dashboard
              ) {
                Store.commit('setToken', response.data.data.user.clients.dashboard.token);
              }
              self.me();
              data.showLoader = false;
            } else {
              data.showLoader = false;
            }
          } else {
            data.showLoader = false;
            data.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
          }
          return response.data;
        })
        .catch((error) => {
          data.showLoader = false;
          data.$toasted.global.error(error.response.data.errorCode);
        });
    });
  },
  sendotp(data) {
    const payload = {
      mode: 'email',
      entity: 'phone_no',
    };

    const payloads = {
      phone_no: data.forgot.hp,
    };

    const payloadwa = {
      mode: 'whatsapp',
      entity: 'phone_no',
    };

    const payloadswa = {
      mode: 'whatsapp',
      entity: 'phone_no',
      phone_no: data.forgot.hp,
    };
    if (data.verificationMethod === 'sms') {
      if (data.registerData.phone_no) {
        return axios
          .post(Config.MS_SOCO_PUBLIC_API_URL + '/auth/otp/code')
          .then((response) => {
            if (response.status == 200) {
              // console.log("suksessss", response.data)
              data.$toasted.global.show('OTP terkirim, silakan cek handphone kamu');
            } else {
              // data.showLoader = false
              data.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
            }
          })
          .catch((error) => {
            if (error.response.status === 403) {
              data.$toasted.global.error('Nomor sudah pernah digunakan');
            } else if (error.response.data.message) {
              data.$toasted.global.error(errorMessageSwitcher(error.response.data.message.toLowerCase()));
            } else {
              data.$toasted.global.error(errorMessageSwitcher(error.response.data.errorCode.toLowerCase()));
            }
          });
      } else if (data.forgot.hp) {
        return axios
          .post(Config.MS_SOCO_PUBLIC_API_URL + '/auth/forget-password', payloads)
          .then((response) => {
            if (response.status == 200) {
              // console.log("sukses", response.data)
              Store.commit('setTempUserId', response.data.data.user_id);
              data.$toasted.global.show('OTP terkirim, silakan cek handphone kamu');
              // this.$store.commit('setTempUserId', response.data.data.user_id)
            } else {
              // data.showLoader = false
              data.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
            }
          })
          .catch((error) => {
            if (error.response.status === 403) {
              data.$toasted.global.error('Nomor sudah pernah digunakan');
            } else if (error.response.data.message) {
              data.$toasted.global.error(errorMessageSwitcher(error.response.data.message.toLowerCase()));
            } else {
              data.$toasted.global.error(errorMessageSwitcher(error.response.data.errorCode.toLowerCase()));
            }
          });
      }
    } else if (data.verificationMethod === 'whatsapp') {
      if (data.registerData.phone_no) {
        return axios
          .post(Config.MS_SOCO_PUBLIC_API_URL + '/auth/otp/code', payloadwa)
          .then((response) => {
            if (response.status == 200) {
              // console.log("suksessss", response.data)
              data.$toasted.global.show('OTP terkirim, silakan cek handphone kamu');
            } else {
              // data.showLoader = false
              data.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
            }
          })
          .catch((error) => {
            if (error.response.status === 403) {
              data.$toasted.global.error('Nomor sudah pernah digunakan');
            } else if (error.response.data.message) {
              data.$toasted.global.error(errorMessageSwitcher(error.response.data.message.toLowerCase()));
            } else {
              data.$toasted.global.error(errorMessageSwitcher(error.response.data.errorCode.toLowerCase()));
            }
          });
      } else if (data.forgot.hp) {
        return axios
          .post(Config.MS_SOCO_PUBLIC_API_URL + '/auth/forget-password', payloadswa)
          .then((response) => {
            if (response.status == 200) {
              // console.log("sukses", response.data)
              Store.commit('setTempUserId', response.data.data.user_id);
              data.$toasted.global.show('OTP terkirim, silakan cek handphone kamu');
              // this.$store.commit('setTempUserId', response.data.data.user_id)
            } else {
              // data.showLoader = false
              data.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
            }
          })
          .catch((error) => {
            if (error.response.status === 403) {
              data.$toasted.global.error('Nomor sudah pernah digunakan');
            } else if (error.response.data.message) {
              data.$toasted.global.error(errorMessageSwitcher(error.response.data.message.toLowerCase()));
            } else {
              data.$toasted.global.error(errorMessageSwitcher(error.response.data.errorCode.toLowerCase()));
            }
          });
      }
    } else if (data.verificationMethod === 'email') {
      return axios
        .post(Config.MS_SOCO_PUBLIC_API_URL + '/auth/otp/code', payload)
        .then((response) => {
          if (response.status == 200) {
            // console.log("sukses", response.data)
            data.$toasted.global.show('Email terkirim, silakan cek email kamu');
          } else {
            // data.showLoader = false
            data.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
          }
        })
        .catch((error) => {
          if (error.response.status === 403) {
            data.$toasted.global.error('Email sudah pernah digunakan');
          } else {
            data.$toasted.global.error(errorMessageSwitcher(error.response.data.errorCode.toLowerCase()));
          }
        });
    } else {
      console.log(data.verificationMethod);
    }
  },

  mergeObject(obj1, obj2) {
    if (typeof obj1 == 'object' && typeof obj2 == 'object') {
      const obj0 = {};
      return Object.assign(obj0, obj1, obj2);
    }
  },

  registerProfile(data) {
    const paramsbeauty = [];
    for (const key in data.beautyField) {
      const subtags = [];
      (data.beautyField[key] || []).map(function (field) {
        if (data.data && data.data[key] && data.data[key].indexOf(field._id) !== -1) {
          subtags.push(field);
        }
      });
      paramsbeauty.push({
        type: 'beauty-profile',
        name: key.split('_').join('-'),
        code: key,
        subtags: subtags,
      });
    }

    return axios
      .post(Config.MS_SOCO_PUBLIC_API_URL + '/user/me/tags/', {
        beauty: paramsbeauty,
        beauty_profile_created_from: 'review_write_review',
      })
      .then((response) => {
        return Boolean(response && response.status === 200);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  registerInterest(params) {
    return axios.post(Config.MS_SOCO_PUBLIC_API_URL + '/user/me/tags/', {
      interest: params,
      newRegister: true,
    });
  },
  async beautyProfile(data) {
    await axios
      .get(Config.MS_SOCO_PUBLIC_API_URL + '/users', {
        params: {
          filter: {
            user_name: `${data.user_name}`,
          },
          fields: 'beauty,interest',
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          const beautyProfile = {
            beauty: '',
            interest: '',
          };
          if (response.data.data[0].beauty && response.data.data[0].beauty.length) {
            beautyProfile.beauty = response.data.data[0].beauty;
          }
          if (response.data.data[0].interest && response.data.data[0].interest.length) {
            beautyProfile.interest = response.data.data[0].interest;
          }
          const userProfile = data;
          const newUserInfo = Object.assign({}, userProfile, beautyProfile);
          Store.commit('profileState', newUserInfo, { module: 'auth' });
          Store.commit('userProfile', newUserInfo, { module: 'auth' });
        }
      })
      .catch(function (error) {
        // data.beautyProfile.push(error);
      });
  },
  CentralAuth: {
    login() {
      const currentURL = window.location.href;
      let redirectURL = centralLoginUrl;
      redirectURL += `?callback_url=${encodeURIComponent(currentURL)}`;
      window.location.href = redirectURL;
    },
    logout() {
      const currentURL = window.location.href;
      let redirectURL = centralLoginUrl + '/api/redirect/';
      const callbackURL = currentURL;
      redirectURL += `?callback_url=${encodeURIComponent(callbackURL)}`;
      window.location.href = redirectURL;
    },
  },
};
